import { render, staticRenderFns } from "./ScratchAndWin.vue?vue&type=template&id=7a61af47&scoped=true"
import script from "./ScratchAndWin.vue?vue&type=script&lang=js"
export * from "./ScratchAndWin.vue?vue&type=script&lang=js"
import style0 from "./ScratchAndWin.vue?vue&type=style&index=0&id=7a61af47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a61af47",
  null
  
)

export default component.exports